import Analytics from '../../../../../../../../analytics';

export const faOnDropdownClick = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.SORT_BY_CLICKED,
    event_value: 'sort_by_clicked',
  });
};
export const faOnDropdownValueSelect = ({ sorterName, sorterValue }) => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.SORT_BY_CLICKED,
    event_value: `sort_by_clicked|${sorterName}|${sorterValue}`,
  });
};
